import React from 'react';
import { pricingPlans } from '../data/mockData';
import { Button } from './ui/button';
import { Check } from 'lucide-react';

const PricingSection = ({ onOpenContactForm }) => {
  return (
    <section id="pricing" className="py-24 bg-white" data-testid="pricing-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">Pricing</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>
            Clear Pricing. No Surprises.
          </h2>
          <p className="text-base text-zinc-500 mt-3">Starting at $45. Government filing fees ($250-$350 per class) are separate.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-200 rounded-lg overflow-hidden max-w-6xl mx-auto">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative flex flex-col p-8 transition-all duration-300 ${
                plan.recommended ? 'bg-[#002FA7] text-white' : 'bento-hover bg-white'
              }`}
              data-testid={`pricing-card-${plan.name.toLowerCase()}`}
            >
              {plan.recommended && (
                <span className="absolute top-4 right-4 text-[9px] tracking-[0.15em] uppercase font-bold bg-white/20 text-white px-2 py-0.5 rounded-full">
                  Popular
                </span>
              )}
              <div className="mb-6">
                <h3 className={`text-sm font-semibold mb-3 ${plan.recommended ? 'text-blue-100' : 'text-zinc-500'}`} style={{fontFamily:'Outfit,sans-serif'}}>{plan.name}</h3>
                <span className={`text-4xl font-black ${plan.recommended ? 'text-white' : 'text-[#09090B]'}`} style={{fontFamily:'Outfit,sans-serif'}}>{plan.price}</span>
                <p className={`text-xs mt-1 ${plan.recommended ? 'text-blue-200' : 'text-zinc-400'}`}>{plan.federal}</p>
              </div>
              <ul className="space-y-3 flex-1 mb-6">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <Check className={`w-4 h-4 mt-0.5 flex-shrink-0 ${plan.recommended ? 'text-blue-200' : 'text-[#002FA7]'}`} />
                    <span className={`text-sm ${plan.recommended ? 'text-blue-100' : 'text-zinc-600'}`}>{feature}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-auto">
                <p className={`text-[10px] text-center mb-3 ${plan.recommended ? 'text-blue-300' : 'text-zinc-400'}`}>{plan.note}</p>
                <Button
                  onClick={onOpenContactForm}
                  className={`w-full font-semibold rounded-md transition-all duration-300 ${
                    plan.recommended
                      ? 'btn-lift bg-white hover:bg-zinc-100 text-[#002FA7]'
                      : 'bg-zinc-100 hover:bg-[#002FA7] hover:text-white text-zinc-700'
                  }`}
                  data-testid={`pricing-btn-${plan.name.toLowerCase()}`}
                >
                  {plan.buttonText}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
